import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class ResourcesTeamsActiveController extends Controller {
  @service favorite;
  @service intl;
  @service store;
  queryParams = ['grouping'];

  @tracked grouping = null;

  get groupingOptions() {
    return [
      {
        label: this.intl.t('_teams.person', {
          num: 1,
        }),
        value: 'person',
      },
    ];
  }

  @action
  addToFavorite(item) {
    this.favorite.addToFavorite(item);
  }

  @action
  removeFromFavorite(item) {
    this.favorite.removeFromFavorite(item);
  }

  get teams() {
    return this.store
      .peekAll('team')
      .filter((item) => item.active)
      .slice();
  }

  @action
  setGrouping(e) {
    this.grouping = e.value;
  }
}
